import { PDFLayout } from "ui/components/PDF";
import ItemTable from "./components/ItemTable/index";
import { View } from "@react-pdf/renderer";
import { CobrancaDetailsExportPdfExcelDataType } from "features/cobranca/typings";
import { formatMoney } from "infra/helpers/number";

interface PDFRelatorioCobrancasProps {
  data?: CobrancaDetailsExportPdfExcelDataType;
}

function PDFRelatorioCobrancas({ data }: PDFRelatorioCobrancasProps) {
  const valores = data?.contas.reduce(
    (acc, next) => {
      return {
        original: (acc.original += next.valor),
        total: (acc.total += next.total),
      };
    },
    { original: 0, total: 0 }
  );

  return (
    <PDFLayout
      fontSize={8}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Cobranças - ${data?.nomeUnidade || "--"}`,
        cards: [
          {
            title: "Original",
            value: formatMoney(valores?.original),
          },
          {
            title: "Total",
            value: formatMoney(valores?.total),
          },
          {
            title: "Data de cálculo",
            value: data?.dataCalculo || "--",
          },
        ],
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      {data?.contas.map((conta, index) => (
        <View
          key={conta.id}
          style={{ marginBottom: index < data?.contas.length - 1 ? 8 : 6 }}
        >
          <ItemTable item={conta} />
        </View>
      ))}
    </PDFLayout>
  );
}

export default PDFRelatorioCobrancas;
